
export const tokens = {
  color: {
    // Brand teal (colors.brown) promoted to the single primary action colour.
    primary: '#249393',
    primaryHover: '#1C7676',
    primaryActive: '#155A5A',
    primarySoft: '#E8F5F5',
    onPrimary: '#FFFFFF',

    // Neutrals. Surface sits on top of canvas; page never uses pure white bg.
    canvas: '#F7F8FA',
    surface: '#FFFFFF',
    surfaceSubtle: '#F9FAFB',
    surfaceHover: '#F3F4F6',

    border: '#E5E7EB',
    borderStrong: '#D1D5DB',

    // Text ramp — all pass 4.5:1 on surface/canvas.
    textPrimary: '#111827',
    textSecondary: '#4B5563',
    textMuted: '#6B7280',

    danger: '#DC2626',
    dangerSoft: '#FEF2F2',
    warning: '#B45309',
    warningSoft: '#FFFBEB',
    success: '#047857',
    successSoft: '#ECFDF5',
    info: '#0369A1',
    infoSoft: '#EFF6FF',

    // Podium. Deliberately not literal metallics — these are darkened so the
    // rank text clears 4.5:1 on a light surface.
    gold: '#B7791F',
    goldSoft: '#FEF6E7',
    silver: '#64748B',
    silverSoft: '#F1F5F9',
    bronze: '#9C4221',
    bronzeSoft: '#FDF2EC',
  },

  // Dense/dashboard scale (density 8/10) — 4px base.
  space: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '48px',
  },

  radius: {
    sm: '6px',
    md: '8px',
    lg: '12px',
    pill: '999px',
  },

  // Single soft elevation scale. Replaces the dual white/black neumorphic glow.
  shadow: {
    sm: '0 1px 2px rgba(16, 24, 40, 0.06)',
    md: '0 1px 3px rgba(16, 24, 40, 0.10), 0 1px 2px rgba(16, 24, 40, 0.06)',
    lg: '0 10px 24px rgba(16, 24, 40, 0.10), 0 3px 6px rgba(16, 24, 40, 0.05)',
    overlay: '0 24px 48px rgba(16, 24, 40, 0.18)',
    focus: '0 0 0 3px rgba(36, 147, 147, 0.28)',
  },

  font: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '20px',
  },

  // Subtle tier (motion 3/10). Anything longer than 220ms feels sluggish here.
  motion: {
    fast: '120ms',
    base: '180ms',
    slow: '220ms',
    ease: 'cubic-bezier(0.2, 0, 0.2, 1)',
  },

  // Min 44x44 hit area for anything tappable.
  touchTarget: '44px',
};

/**
 * Roles allowed to create a policy.
 *
 * Mirrors authorizedRoles("ceo", "admin", "account") in the backend's
 * controllers/policy/policyController.js create route. The old UI also showed
 * the button to "hr", which meant HR users got a 403 after filling the form.
 */
export const POLICY_AUTHOR_ROLES = ['ceo', 'admin', 'account'];

export const canCreatePolicy = (role) => POLICY_AUTHOR_ROLES.includes(role);

/**
 * Roles that can watch the daily race board.
 *
 * These are observer roles, not competitors — raceReportService.getActiveEmployees
 * already excludes "v3" (and "developer") from the ranking itself. Keep this in
 * step with the guard on GET /race-report/hourly-scores.
 */
export const RACE_BOARD_VIEWER_ROLES = ['v3', 'admin'];

export const canViewRaceBoard = (role) => RACE_BOARD_VIEWER_ROLES.includes(role);
